// @ts-nocheck


import React from 'react';


import { budgetLineItemApi } from '../../lib/api';

import AutocompleteSelect from './AutocompleteSelect';


export default (props) =>
<AutocompleteSelect
  placeholder="Выберите статью"
  fetch={budgetLineItemApi.fetch}
  fetchSingle={budgetLineItemApi.get}
  notFoundText="Статьи не найдены"
  renderOption={(budgetLineItem, Option) =>
  <Option value={budgetLineItem.id} key={budgetLineItem.id}>
        {budgetLineItem.mnemocode} {budgetLineItem.name}
      </Option>
  }
  {...props} />;
